module.exports = __webpack_public_path__ + "img/icon_line_cancel.fce3036f.png";